<template>
  <div class="d-flex flex-column gap-6">
    <div>
      <h6 class="mb-2">Últimos logins</h6>
      <v-data-table
        :headers="loginHeaders"
        :items="logins"
        :loading="loading"
        dense
        :items-per-page="10"
        sort-by="createdAt"
        sort-desc
        no-data-text="Nenhum login encontrado"
      >
        <template v-slot:item.createdAt="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ item.createdAt | date("DD/MM/YYYY HH:mm") }}
              </span>
            </template>
            <span>{{ [item.createdAt] | dateDiff(true) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.registering="{ item }">
          {{ item.registering ? "Cadastro" : "Login" }}
        </template>
        <template v-slot:item.success="{ item }">
          <v-chip
            x-small
            label
            :color="item.success ? 'success' : 'error'"
            text-color="white"
          >
            {{ item.success ? "Sucesso" : "Falha" }}
          </v-chip>
        </template>
        <template v-slot:item.ip="{ item }">
          {{ item.ip | cleanIp }}
        </template>
        <template v-slot:item.userAgent="{ item }">
          <v-tooltip v-if="item.userAgent" top max-width="360">
            <template v-slot:activator="{ on }">
              <span v-on="on" class="d-inline-flex align-center" style="max-width: 220px">
                <v-icon small class="mr-1">
                  {{ deviceIcon(item.userAgent) }}
                </v-icon>
                <span class="text-truncate">{{ item.userAgent | deviceLabel }}</span>
              </span>
            </template>
            <span>{{ item.userAgent | deviceDetails }}</span>
          </v-tooltip>
          <span v-else>Não informado</span>
        </template>
      </v-data-table>
    </div>

    <div>
      <h6 class="mb-2">Tokens</h6>
      <v-data-table
        :headers="tokenHeaders"
        :items="tokens"
        :loading="loading"
        dense
        :items-per-page="10"
        sort-by="createdAt"
        sort-desc
        no-data-text="Nenhum token encontrado"
      >
        <template v-slot:item.reason="{ item }">
          {{ tokenReasons[item.reason] || item.reason }}
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip x-small label :color="tokenStatus(item).color" text-color="white">
            {{ tokenStatus(item).text }}
          </v-chip>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ item.createdAt | date("DD/MM/YYYY HH:mm") }}
              </span>
            </template>
            <span>{{ [item.createdAt] | dateDiff(true) }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import platform from "platform";

const DEVICE_ICONS = {
  Windows: "mdi-microsoft-windows",
  "Windows Server 2008 R2 / 7": "mdi-microsoft-windows",
  "Windows Server 2008 / Vista": "mdi-microsoft-windows",
  "Windows XP": "mdi-microsoft-windows",
  "OS X": "mdi-apple",
  Linux: "mdi-linux",
  Ubuntu: "mdi-ubuntu",
  Debian: "mdi-debian",
  Fedora: "mdi-fedora",
  "Red Hat": "mdi-redhat",
  Android: "mdi-android",
  iOS: "mdi-apple-ios",
  "Windows Phone": "mdi-microsoft-windows",
};

export default {
  name: "UserSecurity",
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loginHeaders: [
      { text: "Data", value: "createdAt" },
      { text: "Tipo", value: "registering" },
      { text: "Resultado", value: "success" },
      { text: "IP", value: "ip" },
      { text: "Dispositivo", value: "userAgent", sortable: false },
    ],
    tokenHeaders: [
      { text: "Tipo", value: "reason" },
      { text: "Situação", value: "status", sortable: false },
      { text: "Criado em", value: "createdAt" },
    ],
    tokenReasons: {
      CREATE_ACCOUNT: "Criação de conta",
      RESET_PASSWORD: "Redefinição de senha",
      WEBAUTHN_REGISTER: "Registro de chave de segurança",
      WEBAUTHN_LOGIN: "Login com chave de segurança",
      ACCOUNT_RECOVERY: "Recuperação de conta",
    },
  }),
  computed: {
    logins() {
      return this.user?.LoginAttempt || [];
    },
    tokens() {
      return this.user?.UserToken || [];
    },
  },
  methods: {
    deviceIcon(userAgent) {
      const family = platform.parse(userAgent).os.family;
      return DEVICE_ICONS[family] || "mdi-help";
    },
    tokenStatus(token) {
      if (token.used) return { color: "grey", text: "Usado" };
      if (token.valid) return { color: "success", text: "Válido" };
      return { color: "warning", text: "Expirado" };
    },
  },
  filters: {
    cleanIp(value) {
      return String(value || "").replace("::ffff:", "") || "Não informado";
    },
    deviceLabel(value) {
      const parsed = platform.parse(value);
      const system = parsed.os?.family || "Dispositivo desconhecido";
      return parsed.name ? `${system} · ${parsed.name}` : system;
    },
    deviceDetails(value) {
      const parsed = platform.parse(value);
      const system = [parsed.os?.family, parsed.os?.version].filter(Boolean).join(" ");
      const browser = [parsed.name, parsed.version].filter(Boolean).join(" ");
      return [system, browser].filter(Boolean).join(" · ") || value;
    },
  },
};
</script>
